(function () {
    document.addEventListener('DOMContentLoaded', function () {
        if (!document.body.classList.contains('page-template-product')) {
            return;
        }

        var dropdown = document.querySelector('.wpml-ls-legacy-dropdown');
        if (!dropdown) {
            return;
        }

        // Get the product pathname from the current URL.
        var productPath = window.location.pathname;
        
        // If we're somehow on /product/ instead of /products/{slug}/, we can't
        // fix it client-side. The server should have prevented the redirect.
        if (!productPath.startsWith('/products/')) {
            return;
        }

        // Fix all language links immediately on page load.
        dropdown.querySelectorAll('.wpml-ls-link').forEach(function (link) {
            var langCode = link.getAttribute('lang');
            if (!langCode) {
                return;
            }

            // Build the correct product URL with the language parameter.
            var url = new URL(productPath, window.location.origin);
            url.searchParams.set('lang', langCode);
            link.setAttribute('href', url.toString());
        });
    });
}());
